import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const name = localStorage.getItem("userName");
    const role = localStorage.getItem("userRole");

    if (token && role) {
      setUser({ token, name, role });
    }

    setLoading(false);
  }, []);

  const login = (token, name, role) => {
    localStorage.setItem("token", token);   // <-- use token ONLY
    localStorage.setItem("userName", name);
    localStorage.setItem("userRole", role);

    setUser({ token, name, role });
  };

  const logout = () => {
    localStorage.removeItem("token");        // <-- remove token ONLY
    localStorage.removeItem("userName");
    localStorage.removeItem("userRole");

    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
